const mainColor = '#FFA07D';

const PCTheme = {
  token: {
    colorBgContainerDisabled: '#FAFAFA',
    colorPrimary: mainColor,
    colorError: mainColor,
    Input: {
      activeBorderColor: mainColor,
      hoverBorderColor: mainColor,
      controlHeightLG: 54,
    },
    Form: {
      itemMarginBottom: 41,
      colorError: '#FF946E',
    },
    Button: {
      marginXS: 0,
      defaultBorderColor: mainColor,
      defaultColor: mainColor,
      defaultActiveColor: mainColor,
      borderColorDisabled: '#FAFAFA',
    },
    Menu: {
      itemBorderRadius: 0,
      itemMarginInline: 0,
      itemMarginBlock: 0,
    },
    Pagination: {
      colorBorder: '#000000',
      colorPrimary: '#000000',
      colorText: '#767676',
      colorBgContainer: 'inherit',
      itemSize: 28,
      borderRadius: 2,
    },
    fontFamily: 'Roboto',
  },
};

export { mainColor, PCTheme };
